<!-- <!-- Start Top Header Area -->



<header class="header-area">
    <section class="top-header-area">
        <div class="container-fluid">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <ul class="top-header-contact-info">

                        <!--<li><a routerLink="/tracking"><i class='bx bx-box'></i> {{'Track_your_Order' | translate }}</a></li>-->
                    </ul>
                </div>

                <div class="col-lg-6 col-md-6">
                    <div class="top-header-right">
                        <ul class="d-flex align-items-center justify-content-end">
                            <li>
                                <div class="dropdown language-switcher d-inline-block">
                                    <button class="dropdown-toggle" type="button" (click)="toggleClassLang()">
                                        <img src="{{CurrentLangSrc}}" alt="image">
                                        <span>{{CurrentLangName}} <i class='bx bx-chevron-down'></i></span>
                                    </button>
                                    <div class="dropdown-menu" [class.active]="classApplied">
                                        <button (click)="setLang()" class="dropdown-item d-flex align-items-center">
                                            <img src="{{SecondLangSrc}}" class="shadow-sm" alt="flag">
                                            <span>{{SecondLangName}}</span>
                                        </button>

                                    </div>
                                </div>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>





    <div class="navbar-area navbar-style-two">
        <div class="louise-responsive-nav">
            <div class="container">
                <div class="louise-responsive-menu">
                    <div class="logo">
                        <a routerLink="/">
                            <img src="assets/img/about/booklogo.png" alt="logo">
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="louise-nav">
            <div class="container">
                <nav class="navbar navbar-expand-md navbar-light">
                    <a class="navbar-brand" routerLink="/">
                        <img src="assets/img/about/booklogo.png" alt="logo">
                    </a>

                    <div class="collapse navbar-collapse mean-menu">
                        <ul class="navbar-nav" >
                    
                            <li class="nav-item"><a routerLink="/" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{'Home' | translate }}</a></li>
                         <li class="nav-item"><a routerLink="/shop" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{'Drama' | translate }}</a></li> 
                            <li class="nav-item"><a routerLink="/poetry-book" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{'Poetry' | translate }}</a></li>
                            <li class="nav-item"><a routerLink="/fiction" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{'Fiction' | translate }}</a></li>
                         <!--      <li class="nav-item"><a [routerLink]="['shop', { catID: 68}]" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{'Drama' | translate }}</a></li>
                              <li class="nav-item"><a [routerLink]="['shop', { catID: 75}]" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{'Poetry' | translate }}</a></li>
                           <li class="nav-item"><a [routerLink]="['shop', { catID: 76}]" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{'Fiction' | translate }}</a></li>
                            <li class="nav-item"><a [routerLink]="['shop', { catID: 77}]" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{'Story' | translate }}</a></li> -->
                            <li class="nav-item"><a [routerLink]="['fiction', { catID: 75}]" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{'Islamic_Book' | translate }}</a></li>
                            <li class="nav-item"><a routerLink="/contact" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{'Contact_Us' | translate }}</a></li> 


                        </ul>

                        <div class="others-option">
                            <div class="d-flex align-items-center">
                            <!--     <div class="option-item">
                                    <div class="search-btn-box">
                                        <i class="search-btn bx bx-search-alt"></i>
                                    </div>
                                </div> -->


                                <div class="option-item">
                                    <div class="cart-btn">
                                        <a routerLink="/cart" class="cart-btn"><i class='bx bx-shopping-bag'></i></a>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </div>
    </div>
</header>

